// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-btn[data-v-53a8076e]{max-width:50%!important}.bx--btn-set[data-v-53a8076e]{height:100%}.wizard-checkbox[data-v-53a8076e]{margin-left:16px}.error-notification[data-v-53a8076e]{position:absolute!important;right:0;top:0;height:unset}", ""]);
// Exports
module.exports = exports;
